import React, { ReactNode } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CustomAlert from "../Feedback/CustomAlert";

const ConfirmAbortDialog: React.FC<{
  isOpen: boolean;
  title: string;
  warning?: string;
  description: ReactNode;
  abortButtonText: string;
  confirmButtonText: string;
  confirmButtonDisabled?: boolean;
  onConfirm: () => void;
  onAbort: () => void;
  preventOnClose?: boolean
}> = ({
  isOpen,
  title,
  warning,
  description,
  abortButtonText,
  confirmButtonText,
  confirmButtonDisabled,
  onConfirm,
  onAbort,
  preventOnClose
}) => {

  const abortClickHandler = (event: React.MouseEvent) => {
    event.stopPropagation();
    onAbort();
  };

  const confirmClickHandler = (event: React.MouseEvent) => {
    event.stopPropagation();
    onConfirm();
  };

  const dialogClickHandler = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  let dialogContent;
  if (Array.isArray(description)) {
    dialogContent = description.map((e, i) => {
      return <DialogContentText id="alert-dialog-description" key={i}>{`${e}`}</DialogContentText>;
    });
  } if (typeof description === "string"){
    dialogContent = <DialogContentText id="alert-dialog-description">{description}</DialogContentText>;
  } 
  else {
    dialogContent = description;
  }

  return (
    <Dialog
      open={isOpen}
      onClose={preventOnClose ? undefined : onAbort}
      onClick={dialogClickHandler}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        {warning != null && <CustomAlert severity="warning" header={warning} sx={{ mb: 2 }} />}
        {dialogContent}
      </DialogContent>
      <DialogActions>
        <Button onClick={abortClickHandler} color="primary" data-testid={abortButtonText.replace(" ", "-") + "-id"}>
          {abortButtonText}
        </Button>
        <Button
          onClick={confirmClickHandler}
          color="primary"
          autoFocus
          disabled={confirmButtonDisabled}
          data-testid={confirmButtonText.replace(" ", "-") + "-id"}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmAbortDialog;
